import {useCallback} from 'react'
import {useDropzone} from 'react-dropzone'
import {useTranslation} from 'react-i18next'
import StyleSheet from '../../utils/helpers/styleSheet'

const styles: StyleSheet = {
  container: {
    margin: '30px 40px',
    border: '1px dashed #7ac943',
    backgroundColor: '#eff5ef30',
    padding: '40px 0',
  },
  text: {
    textAlign: 'center',
    fontFamily: 'Calibri',
    fontSize: '1.2em',
  },
}

interface PhotoDropzoneProps {
  onDrop: (acceptedFiles: File[]) => void
}

export default function PhotoDropzone({onDrop}: PhotoDropzoneProps) {
  const {t} = useTranslation()
  const onDrop_ = useCallback(onDrop, [onDrop])
  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    onDrop: onDrop_,
    accept: ['image/jpeg', 'image/png', 'image/bmp'],
  })

  return (
    <div
      {...getRootProps()}
      style={{...getRootProps().style, ...styles.container}}>
      <input {...getInputProps()} />
      {isDragActive ? (
        <p style={styles.text}>{t('Ejtsd ide a képet ...')}</p>
      ) : (
        <p style={styles.text}>{t('Tölts fel saját képet ...')}</p>
      )}
    </div>
  )
}
